'use strict';
angular.module('mandaeApp')
    .controller('HistoricoPedidoForaAreaCtrl', function ($scope) {
        // classe para animação da view
        $scope.pageClass = 'page-fora-area';

    });
